export function congressionalBounds(i) {
  var bounds = {
    20: [
      -119.96005004569543, 34.78865450296283, -117.6165168579814,
      37.100208247774944,
    ],
    23: [
      -118.27235932226809, 34.003815183269396, -114.94815565600447,
      35.809236408082796,
    ],
    26: [
      -119.4545696761183, 33.99285739532015, -118.60620212471842,
      34.901170232526766,
    ],
    27: [
      -118.89463531894332, 34.25732368228298, -117.88021482362308,
      34.82262469314631,
    ],
    28: [
      -118.24875399194511, 34.02699258080738, -117.41054002464655,
      34.499479050721874,
    ],
    29: [
      -118.53608072866483, 34.14217924724784, -118.26847320884279,
      34.43865123640203,
    ],
    30: [
      -118.40594241535031, 34.05276050555152, -118.15209035599702,
      34.43760717421478,
    ],
    31: [
      -118.07292732068686, 33.989371726669454, -117.74225329171277,
      34.33861445626353,
    ],
    32: [
      -118.95172245436197, 33.946904222150046, -118.35588420253158,
      34.27802068886343,
    ],
    34: [
      -118.32670471340612, 34.008045173413734, -118.12672810125456,
      34.15162492402331,
    ],
    35: [
      -117.83586391116614, 33.89271496589584, -117.40146250266939,
      34.121627861697746,
    ],
    36: [
      -118.56311401325839, 33.66664908305732, -118.29834131093021,
      34.11242242374217,
    ],
    37: [
      -118.42142092831277, 33.93820807005029, -118.23791751484808,
      34.06432337493677,
    ],
    38: [
      -118.14416005603478, 33.873321557925316, -117.76704596748074,
      34.06247827263445,
    ],
    40: [
      -117.88002034035623, 33.53304786311343, -117.41298688335311,
      34.02350797623824,
    ],
    42: [
      -118.67854893805048, 32.75004257029633, -118.05892055848554,
      34.01962796346587,
    ],
    43: [
      -118.44655036095214, 33.817037333664075, -118.17994541469669,
      33.98304029254939,
    ],
    44: [
      -118.35200960018341, 33.65954706646204, -118.1092726922877,
      33.96626227925105,
    ],
    45: [
      -118.10856450221603, 33.6867828783444, -117.81626012776357,
      33.94763574225338,
    ],
    47: [
      -118.14780697321173, 33.41897566207966, -117.67801878518492,
      33.78756965248972,
    ],
  };
  return bounds[i];
}
